import type {
  NotificationConfig,
  NotificationDto,
  NotificationHandler,
  NotificationLog,
  NotificationLogList,
  NotificationTemplate,
  PushNotificationDto,
} from '@/models/ExternalNotification';

import { externalNotificationServiceAxios } from './interceptor';

const ExternalNotificationService = {
  // Get Notification Config
  async getNotificationConfig(): Promise<NotificationConfig> {
    const buildUrl = () => {
      const path = `notificationConfig`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await externalNotificationServiceAxios.get(url);
      return res.data;
    } catch (err) {
      throw new Error();
    }
  },

  // Notification Template

  /* List Template By Group 
    notificationTemplate/list?groupId=b16c6f9a-12ff-4cb6-9d23-7a8e60422130
  */

  async getTemplateList(groupId: string): Promise<NotificationTemplate[]> {
    const buildUrl = () => {
      const path = `notificationTemplate/list?groupId=${groupId}`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await externalNotificationServiceAxios.get(url);
      return res.data;
    } catch (err) {
      throw new Error();
    }
  },

  /* Get Template By Group and Id 
   notificationTemplate/TestGroup/3f62914f-ca23-4170-bd4f-23fb91b825d5
  */
  async getTemplate(id: string, groupId: string): Promise<NotificationTemplate> {
    const buildUrl = () => {
      const path = `notificationTemplate/${groupId}/${id}`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await externalNotificationServiceAxios.get(url);
      return res.data;
    } catch (err) {
      throw new Error();
    }
  },
  /* Upsert
  
  */
  async upsertTemplate(data: NotificationTemplate): Promise<NotificationTemplate> {
    const buildUrl = () => {
      const path = `notificationTemplate`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await externalNotificationServiceAxios.post(url, data);
      return res.data;
    } catch (err) {
      throw new Error();
    }
  },
  async deleteTemplate(id: string, groupId: string): Promise<any> {
    const buildUrl = () => {
      const path = `notificationTemplate/${groupId}/${id}`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await externalNotificationServiceAxios.delete(url);
      return res.data;
    } catch (err) {
      throw new Error();
    }
  },
  // Notification Handler

  /* List Template By Group 
    notificationTemplate/list?groupId=b16c6f9a-12ff-4cb6-9d23-7a8e60422130
  */

  async getHandlerListt(queryParams: Record<string, string>): Promise<NotificationHandler[]> {
    const buildUrl = () => {
      let path = `notificationHandler/list`;
      if (queryParams) {
        const qs = Object.keys(queryParams)
          .map((key) => `${key}=${queryParams[key]}`)
          .join('&');
        path += `?${qs}`;
      }
      return path;
    };

    const url = buildUrl();
    try {
      const res = await externalNotificationServiceAxios.get(url);
      return res.data;
    } catch (err) {
      throw err;
    }
  },
  async getHandler(id: string): Promise<NotificationHandler> {
    const buildUrl = () => {
      const path = `notificationHandler/${id}`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await externalNotificationServiceAxios.get(url);
      return res.data;
    } catch (err) {
      throw err;
    }
  },
  async upsertHandler(data: NotificationHandler): Promise<NotificationHandler> {
    const buildUrl = () => {
      const path = `notificationHandler`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await externalNotificationServiceAxios.post(url, data);
      return res.data;
    } catch (err) {
      throw err;
    }
  },
  async deleteHandler(id: string): Promise<any> {
    const buildUrl = () => {
      const path = `notificationHandler/${id}`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await externalNotificationServiceAxios.delete(url);
      return res.data;
    } catch (err) {
      throw err;
    }
  },

  // Send Notification
  async sendNotification(data: NotificationDto | PushNotificationDto): Promise<any> {
    const buildUrl = () => {
      const path = `notification`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await externalNotificationServiceAxios.post(url, data);
      return res.data;
    } catch (err) {
      throw err;
    }
  },

  async getNotificationLogsList(queryParams: Record<string, string>): Promise<NotificationLogList> {
    const buildUrl = () => {
      let path = `notification/list`;
      if (queryParams) {
        const qs = Object.keys(queryParams)
          .map((key) => `${key}=${queryParams[key]}`)
          .join('&');
        path += `?${qs}`;
      }
      return path;
    };

    const url = buildUrl();
    try {
      const res = await externalNotificationServiceAxios.get(url);
      return res.data;
    } catch (err) {
      throw err;
    }
  },
  async deleteNotification(id: string): Promise<any> {
    const buildUrl = () => {
      const path = `notification/${id}`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await externalNotificationServiceAxios.delete(url);
      return res.data;
    } catch (err) {
      throw err;
    }
  },
  async getNotification(id: string): Promise<NotificationLog> {
    const buildUrl = () => {
      const path = `notification/${id}`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await externalNotificationServiceAxios.get(url);
      return res.data;
    } catch (err) {
      throw err;
    }
  },
};

export { ExternalNotificationService };
